//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import HiHeader from "../../components/header/Index.vue";
import HiButton from "../../components/button/Index.vue";
import { createPubliships, createPublishipsByCode } from "../../services/users";
import VerifyModal from "../../components/login/verify_instagram_user_modal/Index";
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";
import { showErrorMsg } from "../../utils/error";
import {
  CURRENT_USER_INFO_SIMPLE,
  CURRENT_PUBLISHER_ID,
} from "../../store/mutation-types";
import RichModal from "../../components/login/send_code/RichModal";
import Radio from "../../components/login/send_code/Radio";
import CodeInput from "../../components/login/send_code/CodeInput";
import { checkpoint as checkpointRes } from "../../apis/publisher";
import { mapGetters } from "vuex";

export default {
  name: "LoginInstagramPage",
  components: { CodeInput, RichModal, Radio, HiHeader, HiButton, VerifyModal },
  mixins: [validationMixin],
  validations: {
    form: {
      username: {
        required,
      },
      password: {
        required,
      },
    },
  },
  data() {
    return {
      form: {
        username: "",
        password: "",
      },
      verify: {
        types: [], // 用户可以选择发送的类型
        typeIndex: 0, // 选中类型索引
        sendError: "", // 发送时候弹出提示
        errorCode: 0, // 2019.5.15 验证码错误添加特殊提示
        timestamp: 0, // 验证码弹出的时间戳，60秒可以再次发送验证码，到时候会刷新时间
        code: "", // 用户输入code
        resetCount: 0, // 重发按钮点击次数
      },
      sendForm: {},
      showVerify: false,
      showSendCode: false,
      type: "",
    };
  },
  methods: {
    /**
     * 登录按钮点击事件
     */
    async loginClick() {
      // 清空错误信息
      this.verify.sendError = "";
      this.verify.code = "";
      // 对登录参数进行校验
      if (!this.$v.form.username.required || !this.$v.form.password.required) {
        this.$alert.show(this.$t("validate.empty"));
        return;
      }
      try {
        this.$loading.show();
        const { publisher } = await this.linkedPublisher();
        // 如果是因为Ins账号数量为0，则绑定成功后回到my plan页面，否则都是统一后退一页
        if (this.type === "noIns") {
          // 如果是因为没有ins账户导致强制登录，则将当前绑定用户设置为active默认选中用户
          this.$store.commit(CURRENT_PUBLISHER_ID, publisher.id);
          this.$router.push({ name: "MyPlanPage" });
        } else {
          this.$router.go(-1);
        }
        this.$toast.show({ message: this.$t("common.success") });
      } catch (e) {
        console.log("error", e);
        if (e.errorCode === 11450) {
          this.$loading.hide();
          await this.$confirm.show({
            text: e.msg,
            yesText: "Help",
          });
          const email = this.user.email;
          window.open(
            `https://mapiz.wufoo.com/forms/apphi-help/def/field3=${email}&field17=${this.form.username}`,
            "_blank"
          );
          return;
        }
        // 当3403说明是is was me
        if (e.errorCode === 3403) {
          this.sendForm = e.responseData.data;
          console.log("this.sendForm", this.sendForm);
          if (this.sendForm) {
            // 弹出选择页面
            if (this.sendForm.next === "validation_method_choice") {
              // 重置验证码选项
              this.resetValidateType();
              // 显示让用户选择页面
              this.showVerify = true;
            } else if (this.sendForm.next === "enter_validation_code") {
              // 显示让用户输入页面
              this.showSendCode = true;
              this.verify.timestamp = new Date().getTime();
              // 清空原来输入项
              this.verify.code = "";
              // 重置点击reset次数
              this.verify.resetCount = 0;
            }
          } else {
            console.error("发现是is me 模式但是 data为空");
          }
          // this.showVerifyModal = true
        } else {
          showErrorMsg(e);
        }
      } finally {
        this.$loading.hide();
      }
    },
    /**
     * 重置验证方式
     */
    resetValidateType() {
      this.verify.types = [];
      if (this.sendForm.phone) {
        this.verify.types.push({
          text: `Phone: ${this.sendForm.phone}`,
          type: 0,
        });
      }
      if (this.sendForm.email) {
        this.verify.types.push({
          text: `Email: ${this.sendForm.email}`,
          type: 1,
        });
      }
    },
    /**
     * 选择验证类型modal确认按钮点击
     */
    async verifyClick() {
      // 调取验证接口
      this.$loading.show();
      try {
        this.sendForm.method = this.verify.types[this.verify.typeIndex].type;
        await this.checkpoint({ action: "send" });
        // 成功后显示发送code
        this.showVerify = false;
        this.showSendCode = true;
        // 重置点击reset次数
        this.verify.resetCount = 0;
      } catch (e) {
        showErrorMsg(e);
      } finally {
        this.$loading.hide();
      }
    },
    /**
     * 关闭发送code组件
     */
    async closeCode() {
      await this.checkpoint({ action: "reset" });
      this.showSendCode = false;
      // 重置点击reset次数
      this.verify.resetCount = 0;
      this.verify.code = "";
      this.verify.sendError = "";
    },
    /**
     * 重新发送验证码
     */
    async resetCode() {
      const currentTime = new Date().getTime();
      if (currentTime - this.verify.timestamp > 60000) {
        this.verify.resetCount += 1;
        this.verify.timestamp = currentTime;
        await this.checkpoint({ action: "replay" });
      } else {
        this.showSendCode = false;
        await this.$confirm.show({
          title: this.$t("verifyModal.moment"),
          text: this.$t("verifyModal.timeOut"),
          cancelText: "",
          yesText: this.$t("verifyModal.ok"),
        });
        this.showSendCode = true;
      }
    },
    async CodeBack() {
      await this.checkpoint({ action: "reset" });
      this.resetValidateType();
      this.showSendCode = false;
      this.showVerify = true;
      this.verify.code = "";
      this.verify.sendError = "";
    },
    /**
     * 发送验证类型modal确认按钮点击
     */
    async sendClick() {
      // 先对输入结果进行验证
      if (!this.verify.code) {
        this.verify.sendError = this.$t("verifyModal.empty");
        return;
      }
      this.sendForm.code = this.verify.code;
      try {
        this.$loading.show();
        // 发送送code
        await createPublishipsByCode({
          ...this.form,
          code: this.verify.code,
          path: this.sendForm.api_path,
        });
        // 全部成功之后清空选项关闭窗口
        this.showSendCode = false;
        this.verify.types = [];
        this.verify.typeIndex = 0;
        this.verify.errorMsg = "";
        this.sendForm = {};
        this.$router.go(-1);
      } catch (e) {
        this.verify.sendError = e.msg;
        this.verify.errorCode = e.errorCode;
      } finally {
        this.$loading.hide();
      }
    },
    /**
     * 因多个地方调用checkpoint 所以统一封装
     */
    async checkpoint({ action }) {
      try {
        this.$loading.show();
        const form = {
          ...this.sendForm,
          action,
        };
        // 提交用户选中类型
        const { data } = await checkpointRes({ form });
        // 拼接发送表单
        this.sendForm.code = data.code;
        return Promise.resolve();
      } catch (e) {
        const { response } = e;
        alert(response.message);
        return Promise.reject(response.message);
      } finally {
        this.$loading.hide();
      }
    },
    /**
     * 绑定publisher
     * @returns {Promise<void>}
     */
    async linkedPublisher() {
      const publisher = await createPubliships(this.form);
      return publisher;
    },
    /**
     * 跳转到my plan 页面
     */
    myPlanClick() {
      this.$router.push({ name: "MyPlanPage" });
    },
  },
  computed: {
    ...mapGetters({
      user: CURRENT_USER_INFO_SIMPLE,
    }),
    verificationNote() {
      const text = this.$t("verifyModal.verificationNote", {
        type: `<span style="font-weight: 600">${this.sendCodeName}</span>`,
      });
      return text;
    },
    /**
     * 计算发送code时加粗文案
     */
    sendCodeName() {
      if (this.sendForm) {
        if (this.sendForm.method === 0) {
          return this.sendForm.phone;
        } else {
          return this.sendForm.email;
        }
      } else {
        return "";
      }
    },
  },
  activated() {
    this.form.username = this.$route.query.username;
    this.form.password = "";
    this.type = this.$route.query.type;
  },
  created() {
    // 当切换页面时判断如果用户名密码已经输入过则自动帮其登录
    document.addEventListener("webkitvisibilitychange", async () => {
      if (
        !this.$v.form.$invalid &&
        this.$route.name === "LoginInstagramPage" &&
        this.$route.query.type === "verify"
      ) {
        this.loginClick();
      }
    });
  },
};



// WEBPACK FOOTER //
// ./src/pages/login/Instagram.vue